export default __webpack_public_path__ + "static/finance-presentation-kz-fed038314771fe158b63c7390c02cf6d.png";